import dynamic from 'next/dynamic';

import { IFirmListEmoji } from 'ati-ui-react/unstyled/components/FirmsListEmoji';

interface IFirmEmoji {
  emoji?: string;
  className?: string;
}

const FirmsListEmoji = dynamic<IFirmListEmoji>(
  () => import('ati-ui-react/unstyled/components/FirmsListEmoji').then(mod => mod.default),
  {
    ssr: false,
  },
);

const FirmEmoji = ({ emoji, className }: IFirmEmoji) => {
  if (!emoji) return null;

  return <FirmsListEmoji data={emoji} groupClassName={className} groupId="firms-list" size={15} />;
};

export { FirmEmoji };
